<script>
  export let className = '';
  export let imageSrc = '';
  export let altText = 'user';
  export let testimonialText = '';
  export let name = '';
</script>


<div class={`flex flex-col max-w-[354px] ${className}`}>
  {#if imageSrc}
    <div class="w-full mb-4">
      <img class="rounded-lg border border-white/45" width="354" height="178" src={imageSrc} alt={altText} />
    </div>
    {:else}
        <div class="w-20 h-2.5 bg-[#5F256C] mb-4 self-start"></div>
    {/if}
  <div class={`text-2xl leading-7 italic font-dm-serif ${imageSrc ? 'text-left md:text-center': 'text-left'}`}>
    {@html testimonialText}
  </div>
  <div class={`font-light opacity-75 text-[17px] leading-[18px] mt-2 ${imageSrc ? 'text-left md:text-center': 'text-left'}`}>– {name}</div>
</div>
